import {PlayerReduxDispatch, PlayerReduxState} from "../types";
import {getCurrentAction, getLevel} from "../selectors";
import {EducationSessionPassedResult, MutationEducationSessionCheckSelectOrVoiceInputArgs} from "../../../schema";
import {analyticsSendEvent} from "../../../libs/analytics";
import {isMultipleChoiceUserInputAction, WithoutTypename} from "../../../types";
import handleUserAnswerResult from "../actionHandlers/handleUserAnswerResult";
import {sessionCheckSelectOrVoiceInputMutation} from "../graphql";

type MultipleSelectInputMediaPayload = {
  audioFileId?: string;
  videoFileId?: string;
  fileUploadData?: any;
};


function multipleSelectInput(arg: number | MultipleSelectInputMediaPayload) {
  return (dispatch: PlayerReduxDispatch, getState: () => PlayerReduxState) => {
    const state = getState();
    const action = getCurrentAction(state);

    if (!action || !isMultipleChoiceUserInputAction(action)) {
      console.warn("multipleSelectInput: wrong action");
      return;
    }
    let recognizedText = "";
    const variables: any = {
      sessionId: state.sessionId!,
      level: getLevel(state),
      actionId: action.id,
    };

    if (typeof arg === "number") {
      variables.index = arg;
    } else if (typeof arg === "object" && arg !== null) {
      const {audioFileId, videoFileId, fileUploadData} = arg;
      variables.uuid = fileUploadData.uuid ?? fileUploadData.id;
      variables.audioUploadId = audioFileId;
      variables.videoUploadId = videoFileId;
      variables.recognizedText = fileUploadData.recognizedText;
      variables.duration = fileUploadData.duration;
      variables.sttError = fileUploadData.isError;
      recognizedText = arg.fileUploadData.recognizedText;
    } else {
      console.warn("multipleSelectInput: wrong input");
      return;
    }

    analyticsSendEvent("playerMultipleSelectChoiceBranchAction", {
      sessionId: state.sessionId!,
      level: getLevel(state),
      actionId: action.id,
      actionType: action.__typename,
    });

    state.client
      .mutate<
        {
          result: WithoutTypename<EducationSessionPassedResult>;
        },
        MutationEducationSessionCheckSelectOrVoiceInputArgs
      >({
        mutation: sessionCheckSelectOrVoiceInputMutation,
        variables,
      })
      .then((mutationResult) => {
        if (!mutationResult.data) {
          console.error("multipleSelectInput: invalid mutation result");
          dispatch({
            type: "update",
            payload: {isRecognizing: false},
          });
          return;
        }

        const result = mutationResult.data.result;
        if (typeof arg !== "number" && result.branchId) {
          dispatch({
            type: "update",
            payload: {chosenBranchesData: new Map(state.chosenBranchesData)
                .set(result.branchId, recognizedText)}
          });
        }
        handleUserAnswerResult({result, state, dispatch, action, challengeMode: state.challenge.mode});
      })
      .catch((err) => {
        dispatch({
          type: "update",
          payload: {isRecognizing: false},
        });

        console.error(err);
      });
  };
}

export default multipleSelectInput;
